import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ResultRow, getGrupoFromMilhar, animalNames } from "./constants";

interface MilharesTabProps {
  filtered: ResultRow[];
}

const MilharesTab: React.FC<MilharesTabProps> = ({ filtered }) => {
  const milharCount: Record<string, number> = {};
  filtered.forEach(r => {
    milharCount[r.milhar] = (milharCount[r.milhar] || 0) + 1;
  });

  const milharTop = Object.entries(milharCount)
    .map(([m, count]) => ({ milhar: m, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 20);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Milhares que Mais Repetiram</CardTitle>
      </CardHeader>
      <CardContent>
        {milharTop.length === 0 ? (
          <p className="text-center text-muted-foreground py-4">
            Nenhum milhar repetido no período selecionado.
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="text-center">Milhar</TableHead>
                <TableHead className="text-center">Grupo</TableHead>
                <TableHead className="text-center">Vezes</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {milharTop.map(m => {
                const grupo = getGrupoFromMilhar(m.milhar);
                return (
                  <TableRow key={m.milhar}>
                    <TableCell className="text-center font-mono font-bold">{m.milhar}</TableCell>
                    <TableCell className="text-center">
                      G{String(grupo).padStart(2, '0')} - {animalNames[grupo] || '?'}
                    </TableCell>
                    <TableCell className="text-center">{m.count}x</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default MilharesTab;
